// Lightbox de la ficha de producto.
//
// Importa PhotoSwipe v5 DIRECTAMENTE, no via assets/gallery.js: ese archivo es
// el de Nook y ademas de PhotoSwipe arrastra Swiper entero (141 KB) para una
// galeria que aqui no usamos. Asi solo entran 13,6 KB en la ficha, y el nucleo
// de 52 KB baja con `pswpModule` al abrir la primera imagen.
//
// El selector es `[data-wh-lightbox]` y NO `.photoswipe` (el que usa Nook) a
// proposito: si algun dia conviven las dos galerias en una pagina, no se
// inicializan la una sobre la otra.
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';

(() => {
  'use strict';
  if (window.WellHomeProductLightbox) return;
  window.WellHomeProductLightbox = true;

  let lightbox = null;

  const init = () => {
    if (!document.querySelector('[data-wh-lightbox]')) return;

    // El editor de temas reemplaza el nodo de la seccion entera, y PhotoSwipe
    // se engancha por delegacion a ese nodo: sin destruir antes, la instancia
    // vieja apunta a un elemento que ya no esta en el DOM y el clic deja de
    // abrir nada.
    lightbox?.destroy();

    lightbox = new PhotoSwipeLightbox({
      gallery: '[data-wh-lightbox]',
      children: 'a.whp-media-zoom',
      pswpModule: () => import('./photoswipe.esm.min.js'),
      // Menos de 1 a proposito: las bandas laterales dejan entrever la ficha,
      // asi se lee que el modal esta ENCIMA de la pagina y no que hemos
      // navegado a otro sitio. El desenfoque va en el CSS de la seccion: solo
      // con transparencia, el texto y los precios de detras compiten con la
      // foto y el modal pierde foco, que es lo contrario de lo que se busca al
      // ampliar un plano acotado. La foto no se ve afectada: va en un elemento
      // aparte, encima y opaco.
      bgOpacity: 0.88,
    });

    lightbox.init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();